import React from 'react';
import { StyledText } from "./basic";
import { MinusIcon, PlusIcon } from "../svgs";

const QuantityControl = ({
  title,
  setValue,
  increment,
  decrement,
  value = 1,
  minValue = 1,
  maxValue = 99,
  iconBackground,
  isEditable = true,
  isCompact,
}) => {
  const handleValueChange = (val) => {
    setValue(val)
  }

  const handleControlClick = (action) => {
    if (isCompact) {
      if (action === 'increase') { increment() } else { decrement(); }
      return;
    }
    if (isNaN(value) || parseFloat(value) - parseInt(value) !== 0) {
      if (setValue) setValue(1);
      return;
    }
    if (action === 'increase') { if (increment) { increment() } else setValue(parseInt(value) + 1) }
    else {
      if (decrement) { decrement() } else setValue(value > 1 ? parseInt(value) - 1 : 1);
    }
  }
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <div style={{ flexGrow: 1 }}>
        <StyledText size={14} style={{ fontFamily: 'MTNMedium' }}>{title}</StyledText>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', minWidth: isCompact ? 'auto' : '100px', cursor: 'pointer' }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          background: isCompact ? iconBackground : 'none',
          borderRadius: '3px',
        }}
          onClick={() => handleControlClick('decrease')}
        >
          <MinusIcon fill={iconBackground} />
        </div>
        {
          isCompact
            ? (
              <div
                style={{
                  fontFamily: 'MTNRegular',
                  fontSize: '12px',
                  display: 'flex',
                  alignItems: 'center',
                  padding: '0 7px',
                }}>
                {value}
              </div>
            )
            : (
              <input
                style={{
                  fontFamily: 'MTNBold',
                  padding: 0,
                  border: 'none',
                  margin: 0,
                  maxWidth: '70px',
                  textAlign: 'center',
                  fontSize: '17px'
                }}
                type={isEditable ? "number" : "text"}
                value={value}
                onChange={e => { if (setValue) handleValueChange(e.target.value) }}
              />
            )
        }
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            cursor: 'pointer',
            background: isCompact ? iconBackground : 'none',
            borderRadius: '3px',
          }}
          onClick={() => handleControlClick('increase')}
        >
          <PlusIcon fill={iconBackground} />
        </div>
      </div>
    </div>
  )
}

export default QuantityControl;